import { StatusedClass } from "./StatusedClass";

export class ExistsCheck extends StatusedClass {
  public overwrite = false;
  public fileReference = "";
  public newFileName = "";
  public suggestedFileName = "";
  public get exists() {
    return (this.fileReference || "").length > 0;
  }
}
